"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSlugs = void 0;
var asArray = string => string ? string.split(',').map(each => each.trim()) : [];
var parseSlugs = (object, string) => string != null && typeof string === 'string' ? asArray(string).map(slug => Object.values(object).find(each => (each.urlSlug || each.name) === slug)).filter(each => each != null).map(each => each.name) : undefined;
exports.parseSlugs = parseSlugs;